module.exports = __webpack_public_path__ + "img/myself04.19216062.png";